import { render, staticRenderFns } from "./PostModal.vue?vue&type=template&id=4d605764&scoped=true"
import script from "./PostModal.vue?vue&type=script&lang=js"
export * from "./PostModal.vue?vue&type=script&lang=js"
import style0 from "./PostModal.vue?vue&type=style&index=0&id=4d605764&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d605764",
  null
  
)

export default component.exports